import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function VerifyWithdrawalComponent(props) {
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  useEffect(() => {
    props.onVerifyWithdrawal({
      token: query.get('t'),
    });
  }, []);

  return (
    <div>
      Verify withdrawal successfully
    </div>
  );
}

export default VerifyWithdrawalComponent;
